import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import Loader from "../../../../comman/Loader";
import {baseUrl, labourType, productType} from "../../../../comman/config";
import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
    const today = new Date().toISOString().split("T")[0];
    const [formData, setFormData] = useState({
        date : today,
        name: "",
        mobile_no:"",
        address: "",
        company_type: "",
        product_type: ""
       
    });
    const [validationErrors, setValidationErrors] = useState({
        date : false,
        name : false,
        mobile_no : false,
        address : false,
        company_type : false,
        product_type : false
        
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();
    
    useEffect(() => {
        if(detail){
            setFormData({
                date: detail[0].date || today,
                name: detail[0].name || "",
                mobile_no: detail[0].mobile_no || '',
                address : detail[0].address || '',
                company_type: labourType.find((val) => val.value == detail[0].company_type),
                product_type : productType.find((val) => val.value == detail[0].product_type),
                db_id: detail[0].id
            });
        }
    }, [detail]);



    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            name: formData.name === '',
            mobile_no: formData.mobile_no === '',
            address: formData.address === '',
            company_type : !formData.company_type.value,
            product_type : !formData.product_type.value,
           
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `admin/profile/company/edit/${detail[0].id}`;
                }else{
                    url = "admin/profile/company/add";
                }
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/admin/profile/company");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        if(option.name == "company_type"){
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
                "product_type" : ""
            }));
            
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
            }));
            
        }
        
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">Company Name</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="name"
                                      name="name"
                                      type="text"
                                      placeholder='Name'
                                      value={formData.name}
                                      onChange={handleInputChange}
                                      className={`block w-full rounded-md border ${validationErrors.name ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.name && <div className="text-red-500">Please enter company name.</div>}
                            </div>
                            
                        </div>
                       
                         <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            
                            <div className="sm:col-span-2">
                                <label htmlFor="mobile_no" className="block text-sm font-medium leading-6 text-gray-900">Mobile No</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="mobile_no"
                                      name="mobile_no"
                                      type="number"
                                      step="0.01"
                                      placeholder='Mobile No'
                                      value={formData.mobile_no}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.mobile_no ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.mobile_no && <div className="text-red-500">Please enter mobile no.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="address" className="block text-sm font-medium leading-6 text-gray-900">Address</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="address"
                                      name="address"
                                      type="text"
                                      placeholder='Address'
                                      value={formData.address}
                                      onChange={handleInputChange}
                                      className={`block w-full rounded-md border ${validationErrors.address ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.address && <div className="text-red-500">Please enter address.</div>}
                            </div>
                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                            <label htmlFor="company_type" className="block text-sm font-medium leading-6 text-gray-900">Company Type</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.company_type}
                                        name="company_type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={labourType.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.company_type && <div className="text-red-500">Please select a company type.</div>}
                            </div>
                            <div className="sm:col-span-2">
                            <label htmlFor="product_type" className="block text-sm font-medium leading-6 text-gray-900">Product Type</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.product_type}
                                        name="product_type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={productType.filter((val) => val.company_type == formData.company_type.value).map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.product_type && <div className="text-red-500">Please select a product type.</div>}
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/admin/profile/company">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }